module.exports = __webpack_public_path__ + "static/recommendation@3x-23092b720373cfe60972f086e5674597.png";